import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        accountTitle: {
            textStyle: 'head-large',
            marginTop: remCalc(12),
            paddingBottom: {base: 0, sm: remCalc(24), md: 0},
            paddingY: {base: 0, lg: remCalc(12)},
            paddingTop: {base: remCalc(16), lg: remCalc(24)},
            fontWeight: 500,
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        accountTitleDetails: {
            textStyle: 'head-large',
            fontWeight: 500,
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            marginTop: remCalc(24),
            paddingBottom: remCalc(24),
        },
        subscriptionGap: {
            marginTop: {base: remCalc(24), lg: remCalc(40)},
            gap: 'small.lg',
        },
        assistanceContainer: {
            display: 'flex',
            flexDir: 'column',
            backgroundColor: 'background.light',
            padding: remCalc(24),
            borderRadius: 'large.lg',
        },
        assistanceButton: {
            maxWidth: remCalc(332),
        },
        assistanceTitle: {
            textStyle: 'head-xsmall',
            color: 'text.default',
            fontWeight: '500',
            lineHeight: 'head-xsmall',
        },
        assistanceDescription: {
            textStyle: 'body-small',
            color: 'text.default',
        },
        subscriptionNumberHeader: {
            textStyle: 'head-medium',
            color: 'text.default',
            fontWeight: '500',
            pt: {base: remCalc(16), md: remCalc(18)},
            pb: remCalc(16),
            wordBreak: 'break-word',
        },
        subscriptionBoxContainer: {
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            borderRadius: 'large.lg',
            display: 'flex',
            flexDir: 'column',
            padding: remCalc(24),
        },
        subscriptionBoxUpContainer: {
            columns: {base: 1, md: 4},
            gap: remCalc(24),
            w: '100%',
        },
        subscriptionBoxLabel: {
            fontWeight: '700',
        },
        subscriptionInnerBoxContainer: {
            w: '100%',
        },
        subscriptionStatusDetailsContainer: {
            display: 'flex',
            w: '100%',
        },
        subscriptionStatusContainer: {
            w: `calc(100% - ${remCalc(60)})`,
        },
        subscriptionDetailsLabelContainer: {
            w: remCalc(60),
            paddingTop: remCalc(24),
        },
        subscriptionDetailsLabel: {
            textDecoration: 'underline',
            color: 'text.tertiary',
            cursor: 'pointer',
        },
        noSubscriptionsContainer: {
            gap: remCalc(16),
            alignItems: 'flex-start',
        },
        noSubscriptionsTitle: {
            color: 'text.default',
            fontWeight: '500',
            textStyle: 'head-medium',
        },
        noSubscriptionsDescription: {
            color: 'text.default',
            textStyle: 'body-medium',
        },
        subscriptionBoxBottomContainer: {
            mt: remCalc(24),
        },
        selectOrderContainer: {
            display: 'flex',
            flexDirection: {base: 'column', md: 'row'},
            mt: remCalc(24),
        },
        selectOrderSelect: {
            w: '100%',
            maxW: {base: 'unset', md: remCalc(332)},
        },
        selectOrderButton: {
            ml: {base: remCalc(0), md: remCalc(24)},
            mt: {base: remCalc(24), md: remCalc(0)},
            px: remCalc(50),
        },
        subscriptionDetailsList: {
            listStyleType: 'none',
        },
        infoContainer: {
            paddingTop: remCalc(12),
        },
        infoNameContainer: {
            flexDirection: 'column',
            marginBottom: remCalc(8),
        },
        infoExpirationContainer: {
            flexDirection: 'column',
        },
        infoLabel: {
            color: 'text.secondary',
            textStyle: ['body-medium'],
        },
        infoValue: {
            textStyle: ['body-medium'],
        },
    },
}
